import {
  CircularProgress,
  ImageList,
  ImageListItem,
  Typography,
} from '@mui/material';
import classNames from 'classnames';
import { MultiMediaListHeaderTitle } from 'components/MediaInput/MultimediaPlugin/MultimediaPlugin/Content/MultiMediaListHeaderTitle';
import { ViewMode } from 'components/MediaInput/MultimediaPlugin/types';
import { FC } from 'react';
import { NO_RESULT_TEXT } from '../constants';
import { GridViewProps, MultiMediaListItemType } from '../types';
import { GridItemCard } from './GridItemCard';
import { THUMBNAIL_GRID_HEIGHT, useStyles } from './styles';

const NB_COLS = 3;

export const GridView: FC<GridViewProps> = ({
  allowSearch,
  className,
  isBusy,
  isLoading,
  itemToRender,
  items,
  onItemClick,
  pluginType,
  selectedItems,
  viewMode = ViewMode.GRID,
  ...restGridViewProps
}) => {
  const classes = useStyles({ allowSearch, viewMode });

  if (!items.length) {
    return (
      <div className={classes.centered}>
        {isLoading ? (
          <CircularProgress color="primary" size={80} />
        ) : (
          <Typography variant="h4" color="primary">
            {NO_RESULT_TEXT}
          </Typography>
        )}
      </div>
    );
  }

  return (
    <div className={classNames(className, classes.wrapperGrid)}>
      <ImageList
        className={classes.gridList}
        cols={NB_COLS}
        rowHeight={THUMBNAIL_GRID_HEIGHT}
      >
        {items.map((rowItem, index) => {
          if (rowItem.type === MultiMediaListItemType.HEADING) {
            return (
              <ImageListItem key={index} cols={3} style={{ height: '20px' }}>
                <MultiMediaListHeaderTitle title={rowItem.text} />
              </ImageListItem>
            );
          }

          const itemPluginType = rowItem.pluginType || pluginType;
          const item = itemToRender(rowItem, itemPluginType);
          const isSelected =
            viewMode === ViewMode.GRID &&
            selectedItems.some((selectedItem) => selectedItem.id === item.id);

          return (
            <div key={item.id}>
              <GridItemCard
                {...item}
                {...restGridViewProps}
                isBusy={isBusy && isSelected}
                isSelected={isSelected}
                onItemClick={() => {
                  onItemClick(rowItem, itemPluginType);
                }}
                isSuggestionItem={rowItem.isSuggested}
                viewMode={viewMode}
              />
            </div>
          );
        })}
      </ImageList>
    </div>
  );
};
